import { UserRegisterService } from 'src/app/layouts/admin-layout/services/user-register/user-register.service'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { UserInfo } from 'src/app/models/auth.model'
import { IBadgePlayer } from 'src/app/models/badge.model'
import { fadeInRight400ms } from 'src/@vex/animations/fade-in-right.animation'
import { scaleFadeIn400ms } from 'src/@vex/animations/scale-fade-in.animation'
import { scaleIn400ms } from 'src/@vex/animations/scale-in.animation'
import { stagger40ms } from 'src/@vex/animations/stagger.animation'
import { PlayersDetailsService } from 'src/app/services/palyers-details/players-details.service'

@Component({
  selector: 'app-players-details-badges',
  templateUrl: './players-details-badges.component.html',
  styleUrls: ['./players-details-badges.component.scss'],
  animations: [
    scaleIn400ms,
    fadeInRight400ms,
    stagger40ms,
    scaleFadeIn400ms
  ]
})
export class PlayersDetailsBadgesComponent implements OnInit {
  userId: string
  teamId: string
  user: UserInfo
  badges: IBadgePlayer[]
  loading: boolean = false
  territoryId: string
  constructor (
    private readonly userRegisterService: UserRegisterService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly playersDetailsService: PlayersDetailsService
  ) { }

  ngOnInit (): void {
    this.loading = true
    this.activatedRoute.params.subscribe(
      (params: {
        userId: string
        territoryId: string
        teamId: string
        activeCategory: string
      }) => {
        this.userId = params.userId
        this.teamId = params.teamId
        this.territoryId = params.territoryId
      }
    )
    this.getBadges(this.userId)
  }

  getBadges (userId: string): void {
    this.playersDetailsService.getBadgesFromUser(userId).subscribe((res: {userBadges: IBadgePlayer[]}) => {
      this.badges = res.userBadges
      this.loading = false
    })
  }
}
